require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-develop-our-discovery-process.json") })
        }
      }, "path---service-develop-our-discovery-process");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-develop-our-discovery-process!./.cache/json/service-develop-our-discovery-process.json
// module id = 901
// module chunks = 231608221292675